// Stage 14F+: pure formatting for compare facts. Descriptive only: no scores, no winner.
export const FEE_CATEGORIES = [
  { key: "unset", label: "Not chosen" },
  { key: "home", label: "Home" },
  { key: "international", label: "International" },
];

export const homeFeeLabel = (country) => (country === "UK" ? "Home (UK) fee" : "Home / domestic fee");

export function listed(m, per) {
  if (!m) return "";
  const s = new Intl.NumberFormat("en-GB", { style: "currency", currency: m.currency, maximumFractionDigits: 0 }).format(m.amount);
  return s + per;
}

export function budgetLine(diffUsd, budget, fmt) {
  if (!budget) return "No living budget saved in your profile, so there's nothing to compare against.";
  if (diffUsd === null || diffUsd === undefined) return "";
  const b = fmt(budget.monthly_usd) + "/month budget you saved";
  if (Math.abs(diffUsd) < 10) return "About the same as the " + b + ".";
  return "About " + fmt(Math.abs(diffUsd)) + "/month " + (diffUsd > 0 ? "above" : "below") + " the " + b + ".";
}

export function livingGap(a, b, fmt) {
  if (!a?.living || !b?.living) return null;
  const d = a.living.usd - b.living.usd;
  if (Math.abs(d) < 10) return "Estimated living costs are about the same in " + a.city_name + " and " + b.city_name + ".";
  const [hi, lo] = d > 0 ? [a, b] : [b, a];
  return "Estimated living costs in " + hi.city_name + " are about " + fmt(Math.abs(d)) + "/month higher than in " + lo.city_name + ".";
}

export function tuitionFor(o, category) {
  const t = o?.tuition;
  if (!t || category === "unset") return null;
  return t[category] || null;
}

// Only a full total: chosen fee category + listed tuition + living estimate. Otherwise say what's missing.
export function yearlyTotal(o, category) {
  if (category === "unset") return { missing: ["your fee category"] };
  const missing = [];
  const fee = tuitionFor(o, category);
  if (!fee) missing.push((category === "home" ? "home" : "international") + " tuition fee");
  if (!o?.living) missing.push("living-cost estimate");
  if (missing.length) return { missing };
  return { usd: fee.usd + o.living.usd * 12 };
}

export function regionLine(o, pref) {
  const r = o?.region || {};
  if (!pref) return null;
  if (r.in_preferred === null || r.in_preferred === undefined) return { tone: "missing", text: "Region not known for this city, so we can't check it against " + pref.area + "." };
  if (r.in_preferred) return { tone: "ok", text: "In " + pref.area + ", where you said you'd prefer to study." };
  return pref.strength === "hard"
    ? { tone: "hard", text: "In " + r.label + ", outside " + pref.area + ". You said studying there is a must." }
    : { tone: "soft", text: "In " + r.label + ", outside " + pref.area + ". You said you'd prefer " + pref.area + ", not that it's a must." };
}

export function homeNote(home) {
  if (!home) return "You haven't told us where home is, so no distances are shown.";
  if (home.geo && !home.geo.approx) return null;
  if (home.declined) return "You preferred not to say where home is, so no distances are shown.";
  if (home.geo?.approx) return "Home given only as " + home.geo.label + ", which is too broad for a distance.";
  if (home.region_only) return "Home given only as " + home.region_only + ", which is too broad for a distance.";
  return "We couldn't place the home you described on a map, so no distances are shown.";
}
